<template>
  <div id="ad-container">
    <ins class="adsbygoogle"
         style="display:block"
         data-ad-client="ca-pub-6734004389316610"
         data-ad-slot="4898069421"
         data-ad-format="auto"
         data-full-width-responsive="true"
         data-adtest="on"
         data-ad-test="on"
         ></ins>
  </div>
</template>
<script setup>
import { onMounted } from 'vue';

onMounted(() => {
  (window.adsbygoogle = window.adsbygoogle || []).push({});
});

</script>